import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/FileInput/FileListItem.js",
  _this = this,
  _templateObject;
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { Close as CloseIcon, Document as DocumentIcon } from '@dls/assets/icons';
import loadingAnimation from '@dls/assets/lottiefiles/loading';
import tickAnimation from '@dls/assets/lottiefiles/tick';
import Animation from '../Animation';
import { withTheme } from '../../core/ThemeProvider';
import { testIdProps } from '../../helpers';
import { responsiveStyles } from '../../core/utils/responsiveStyles';
import Config from '../../config';
export var FileUploadStatus = {
  LOADING: 'loading',
  SUCCESS: 'success',
  FAILURE: 'failure'
};
export var FileType = {
  IMAGE: 'image',
  APPLICATION: 'application'
};
export var ListType = {
  TEXT: 'text',
  PICTURE: 'picture'
};
var FileListItem = withTheme(function (props) {
  /* Start animations if status prop is set. */
  var _useState = useState(props.status),
    _useState2 = _slicedToArray(_useState, 2),
    animActive = _useState2[0],
    setAnimActive = _useState2[1];
  var action = props.action,
    status = props.status,
    error = props.error,
    index = props.index,
    size = props.size,
    imageSrc = props.imageSrc,
    isFullWidth = props.isFullWidth,
    _props$fileType = props.fileType,
    fileType = _props$fileType === void 0 ? FileType.IMAGE : _props$fileType,
    _props$listType = props.listType,
    listType = _props$listType === void 0 ? ListType.PICTURE : _props$listType,
    _props$animate = props.animate,
    animate = _props$animate === void 0 ? true : _props$animate;
  var isFileLoading = function isFileLoading(uploadStatus) {
    return uploadStatus === FileUploadStatus.LOADING;
  };
  var renderStatus = function renderStatus(uploadStatus) {
    if (uploadStatus === FileUploadStatus.FAILURE) {
      setTimeout(function () {
        setAnimActive(false);
      }, 2000);
      return /*#__PURE__*/React.createElement(CloseIcon, {
        size: 22,
        color: props.coreTheme.cl_pri_d3,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 57,
          columnNumber: 14
        }
      });
    }
    var isLoading = isFileLoading(uploadStatus);
    return /*#__PURE__*/React.createElement(StatusWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 63,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Animation, {
      "data-testid": "lottie-animation",
      source: isLoading ? loadingAnimation : tickAnimation,
      size: "22px",
      color: !isLoading && props.coreTheme.cl_successGreen,
      action: "play",
      loop: isLoading,
      onComplete: function onComplete() {
        return !isLoading && setAnimActive(false);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 64,
        columnNumber: 9
      }
    }), listType === ListType.PICTURE ? /*#__PURE__*/React.createElement(StatusTextWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 74,
        columnNumber: 11
      }
    }, isLoading && /*#__PURE__*/React.createElement(LoadingText, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 75,
        columnNumber: 27
      }
    }, "Loading"), !isLoading && /*#__PURE__*/React.createElement(UploadedText, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 76,
        columnNumber: 28
      }
    }, "Uploaded")) : null);
  };
  var renderAsset = function renderAsset(src, fileName) {
    if (fileType === FileType.IMAGE) {
      return /*#__PURE__*/React.createElement(UploadedImage, {
        src: src,
        "class": "fs-exclude",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 85,
          columnNumber: 14
        }
      });
    }
    return /*#__PURE__*/React.createElement(UploadedDocumentWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 89,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(UploadedDocument, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 90,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(DocumentIcon, {
      size: 24,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 91,
        columnNumber: 11
      }
    }), /*#__PURE__*/React.createElement(TextFileNameWrapper, {
      "data-testid": "picture-file-name",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 92,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(TextFileName, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 93,
        columnNumber: 13
      }
    }, fileName))));
  };
  if (error) {
    return null;
  }
  var renderContent = function renderContent() {
    var fileName = '';
    var nameFirstPart = '';
    var nameLastPart = '';
    if (props.children) {
      fileName = props.children;
      nameLastPart = fileName && fileName.length > 8 ? fileName.substr(fileName.length - 8, fileName.length) : '';
      nameFirstPart = fileName ? fileName.replace(nameLastPart, '') : '';
    }
    if (listType === ListType.TEXT) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FileInfo, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 121,
          columnNumber: 11
        }
      }, /*#__PURE__*/React.createElement(StyledFileNameWrapper, {
        "data-testid": "file-name",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 122,
          columnNumber: 13
        }
      }, /*#__PURE__*/React.createElement(NameFirstPart, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 123,
          columnNumber: 15
        }
      }, nameFirstPart), /*#__PURE__*/React.createElement(NameLastPart, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 124,
          columnNumber: 15
        }
      }, nameLastPart))), /*#__PURE__*/React.createElement(ActionContainer, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 127,
          columnNumber: 11
        }
      }, status && animActive && renderStatus(status), action && !animActive && action));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, !isFullWidth && /*#__PURE__*/React.createElement(FileInfo, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 138,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(FileNameWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 139,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement("span", {
      "data-testid": "file-name",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 140,
        columnNumber: 15
      }
    }, size ? "".concat(index + 1, "/").concat(size) : ''), action && !animActive && action)), /*#__PURE__*/React.createElement(FileWrapper, {
      isLoading: isFileLoading(status),
      isFullWidth: isFullWidth,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 147,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(FileContainer, {
      "data-testid": "file-container",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 151,
        columnNumber: 11
      }
    }, animate && /*#__PURE__*/React.createElement(React.Fragment, null, status && animActive && renderStatus(status), !animActive && imageSrc && renderAsset(imageSrc, fileName)), !animate && /*#__PURE__*/React.createElement(React.Fragment, null, imageSrc && renderAsset(imageSrc, fileName)))));
  };
  if (listType === ListType.TEXT) {
    return /*#__PURE__*/React.createElement(FileItemRow, _extends({}, testIdProps(props), {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 167,
        columnNumber: 12
      }
    }), renderContent());
  } else {
    if (isFullWidth) {
      return /*#__PURE__*/React.createElement(FileListItemRowFullWidth, _extends({}, testIdProps(props), {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 171,
          columnNumber: 9
        }
      }), renderContent());
    }
    return /*#__PURE__*/React.createElement(FileListItemRow, _extends({}, testIdProps(props), {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 178,
        columnNumber: 7
      }
    }), renderContent());
  }
});
export var ListItemWrapper = withTheme(styled.div.withConfig({
  displayName: "FileListItem__ListItemWrapper",
  componentId: "sc-15kel3f-0"
})(["display:flex;flex-direction:row;flex-wrap:wrap;"]));
var FileNameWrapper = withTheme(styled.div.withConfig({
  displayName: "FileListItem__FileNameWrapper",
  componentId: "sc-15kel3f-1"
})(["white-space:nowrap;overflow:hidden;", ";font-family:", ";color:", ";line-height:30px;padding:", " 0;display:flex;flex-wrap:wrap;justify-content:space-between;"], function (_ref) {
  var _coreTheme$fileInput, _coreTheme$fileInput2;
  var coreTheme = _ref.coreTheme;
  return (coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$fileInput = coreTheme.fileInput) === null || _coreTheme$fileInput === void 0 ? void 0 : _coreTheme$fileInput.fontSize) && Object.assign({}, responsiveStyles({
    fontSize: (coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$fileInput2 = coreTheme.fileInput) === null || _coreTheme$fileInput2 === void 0 ? void 0 : _coreTheme$fileInput2.fontSize) || coreTheme.fs_xl
  }, coreTheme));
}, function (p) {
  var _p$coreTheme$fileInpu, _p$coreTheme, _p$coreTheme$fileInpu2;
  return (_p$coreTheme$fileInpu = (_p$coreTheme = p.coreTheme) === null || _p$coreTheme === void 0 ? void 0 : (_p$coreTheme$fileInpu2 = _p$coreTheme.fileInput) === null || _p$coreTheme$fileInpu2 === void 0 ? void 0 : _p$coreTheme$fileInpu2.fontFamily) !== null && _p$coreTheme$fileInpu !== void 0 ? _p$coreTheme$fileInpu : p.coreTheme.ff_sec_thin;
}, function (p) {
  return p.coreTheme.cl_ter_base;
}, function (p) {
  return p.coreTheme.space_5;
}));
var TextFileNameWrapper = withTheme(styled.div.withConfig({
  displayName: "FileListItem__TextFileNameWrapper",
  componentId: "sc-15kel3f-2"
})(["", ";font-family:", ";color:", ";line-height:30px;"], function (_ref2) {
  var _coreTheme$fileInput3, _coreTheme$fileInput4;
  var coreTheme = _ref2.coreTheme;
  return (coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$fileInput3 = coreTheme.fileInput) === null || _coreTheme$fileInput3 === void 0 ? void 0 : _coreTheme$fileInput3.fontSize) && Object.assign({}, responsiveStyles({
    fontSize: (coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$fileInput4 = coreTheme.fileInput) === null || _coreTheme$fileInput4 === void 0 ? void 0 : _coreTheme$fileInput4.fontSize) || coreTheme.fs_xl
  }, coreTheme));
}, function (p) {
  var _p$coreTheme$fileInpu3, _p$coreTheme2, _p$coreTheme2$fileInp;
  return (_p$coreTheme$fileInpu3 = (_p$coreTheme2 = p.coreTheme) === null || _p$coreTheme2 === void 0 ? void 0 : (_p$coreTheme2$fileInp = _p$coreTheme2.fileInput) === null || _p$coreTheme2$fileInp === void 0 ? void 0 : _p$coreTheme2$fileInp.fontFamily) !== null && _p$coreTheme$fileInpu3 !== void 0 ? _p$coreTheme$fileInpu3 : p.coreTheme.ff_sec_thin;
}, function (p) {
  return p.coreTheme.cl_ter_base;
}));
var TextFileName = styled.span.withConfig({
  displayName: "FileListItem__TextFileName",
  componentId: "sc-15kel3f-3"
})(["overflow-wrap:break-word;"]);
var StyledFileNameWrapper = styled(FileNameWrapper).withConfig({
  displayName: "FileListItem__StyledFileNameWrapper",
  componentId: "sc-15kel3f-4"
})(["justify-content:start;"]);
var NameFirstPart = styled.span.withConfig({
  displayName: "FileListItem__NameFirstPart",
  componentId: "sc-15kel3f-5"
})(["overflow:hidden;text-overflow:ellipsis;display:inline-block;vertical-align:bottom;max-width:calc(100% - 100px);"]);
var NameLastPart = styled.span.withConfig({
  displayName: "FileListItem__NameLastPart",
  componentId: "sc-15kel3f-6"
})(["width:100px;display:inline-block;vertical-align:bottom;"]);
var UploadedImage = styled.img.attrs(function (props) {
  return {
    src: props.src
  };
}).withConfig({
  displayName: "FileListItem__UploadedImage",
  componentId: "sc-15kel3f-7"
})(["width:100%;height:100%;object-fit:cover;border:0;"]);
var UploadedDocumentWrapper = styled.div.withConfig({
  displayName: "FileListItem__UploadedDocumentWrapper",
  componentId: "sc-15kel3f-8"
})(["width:100%;height:100%;border:0;display:flex;justify-content:center;align-items:center;"]);
var UploadedDocument = styled.div.withConfig({
  displayName: "FileListItem__UploadedDocument",
  componentId: "sc-15kel3f-9"
})(["width:100%;display:flex;flex-direction:column;& > *{align-self:center;text-align:center;margin:5px;width:80%;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;}"]);
var FileListItemRowFullWidth = withTheme(styled.div.withConfig({
  displayName: "FileListItem__FileListItemRowFullWidth",
  componentId: "sc-15kel3f-10"
})(["display:flex;flex-direction:column;overflow:auto;flex:1;height:100%;"]));
var FileItemRow = withTheme(styled.div.withConfig({
  displayName: "FileListItem__FileItemRow",
  componentId: "sc-15kel3f-11"
})(["display:flex;width:100%;justify-content:space-between;align-items:center;margin:", "px 0;"], function (p) {
  return p.coreTheme.space_3;
}));
var FileListItemRow = withTheme(styled.div.withConfig({
  displayName: "FileListItem__FileListItemRow",
  componentId: "sc-15kel3f-12"
})(["display:flex;flex-direction:column;margin:", "px 0;overflow:auto;flex:1 0 48%;max-width:calc(50% - ", "px);margin-right:", "px;&:nth-child(2n){margin-right:0;}", ""], function (p) {
  return p.coreTheme.space_4;
}, function (p) {
  return 1 / 2 * p.coreTheme.space_5;
}, function (p) {
  return p.coreTheme.space_5;
}, Config.media.sm(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      flex: 1 0 31%;\n      max-width: calc(33.3% - ", "px);\n    \n      &:nth-child(2n) {\n         margin-right: ", "px;\n      }\n      &:nth-child(3n) {\n        margin-right: 0;\n      }\n    "])), function (p) {
  return 2 / 3 * p.coreTheme.space_5;
}, function (p) {
  return p.coreTheme.space_5;
})));
var StatusWrapper = styled.div.withConfig({
  displayName: "FileListItem__StatusWrapper",
  componentId: "sc-15kel3f-13"
})(["display:flex;align-items:flex-start;justify-content:center;"]);
var StatusText = withTheme(styled.span.withConfig({
  displayName: "FileListItem__StatusText",
  componentId: "sc-15kel3f-14"
})(["", ";font-family:", ";line-height:30px;"], function (_ref3) {
  var _coreTheme$fileInput5, _coreTheme$fileInput6;
  var coreTheme = _ref3.coreTheme;
  return coreTheme !== null && coreTheme !== void 0 && (_coreTheme$fileInput5 = coreTheme.fileInput) !== null && _coreTheme$fileInput5 !== void 0 && _coreTheme$fileInput5.fontSize ? Object.assign({}, responsiveStyles({
    fontSize: coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$fileInput6 = coreTheme.fileInput) === null || _coreTheme$fileInput6 === void 0 ? void 0 : _coreTheme$fileInput6.fontSize
  }, coreTheme)) : {
    fontSize: coreTheme.fs_xl
  };
}, function (p) {
  var _p$coreTheme$fileInpu4, _p$coreTheme3, _p$coreTheme3$fileInp;
  return (_p$coreTheme$fileInpu4 = (_p$coreTheme3 = p.coreTheme) === null || _p$coreTheme3 === void 0 ? void 0 : (_p$coreTheme3$fileInp = _p$coreTheme3.fileInput) === null || _p$coreTheme3$fileInp === void 0 ? void 0 : _p$coreTheme3$fileInp.fontFamily) !== null && _p$coreTheme$fileInpu4 !== void 0 ? _p$coreTheme$fileInpu4 : p.coreTheme.ff_sec_thin;
}));
var LoadingText = withTheme(styled(StatusText).withConfig({
  displayName: "FileListItem__LoadingText",
  componentId: "sc-15kel3f-15"
})(["color:", ";"], function (p) {
  return p.coreTheme.cl_ter_l3;
}));
var UploadedText = withTheme(styled(StatusText).withConfig({
  displayName: "FileListItem__UploadedText",
  componentId: "sc-15kel3f-16"
})(["color:", ";"], function (p) {
  return p.coreTheme.cl_successGreen;
}));
var StatusTextWrapper = withTheme(styled.div.withConfig({
  displayName: "FileListItem__StatusTextWrapper",
  componentId: "sc-15kel3f-17"
})(["margin-left:", "px;"], function (p) {
  return p.coreTheme.space_3;
}));
var FileInfo = styled.span.withConfig({
  displayName: "FileListItem__FileInfo",
  componentId: "sc-15kel3f-18"
})(["flex:1;overflow-wrap:break-word;overflow:hidden;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;"]);
var ActionContainer = styled.span.withConfig({
  displayName: "FileListItem__ActionContainer",
  componentId: "sc-15kel3f-19"
})(["display:flex;min-width:36px;height:24px;align-items:center;justify-content:center;"]);
var FileWrapper = withTheme(styled.div.withConfig({
  displayName: "FileListItem__FileWrapper",
  componentId: "sc-15kel3f-20"
})(["", ""], function (_ref4) {
  var isFullWidth = _ref4.isFullWidth,
    isLoading = _ref4.isLoading;
  return css(["border:1px ", " ", ";border-radius:", ";padding-bottom:", ";position:relative;overflow:hidden;flex:", ";"], isLoading ? 'dashed' : 'solid', isLoading ? function (p) {
    return p.coreTheme.cl_sec_d1;
  } : function (p) {
    return p.coreTheme.cl_divider;
  }, function (p) {
    return p.coreTheme.rad_xs;
  }, isFullWidth ? 0 : "100%", isFullWidth ? 1 : 'none');
}));
var FileContainer = withTheme(styled.div.withConfig({
  displayName: "FileListItem__FileContainer",
  componentId: "sc-15kel3f-21"
})(["display:flex;align-items:center;justify-content:center;position:absolute;top:0;left:0;right:0;bottom:0;"]));
export default FileListItem;